import {
  SET_SEARCH_TEXT_WIDTH,
  SET_SEARCH_VERTICAL_PADDING,
  SET_SEARCH_TEXT_BG_COLOR,
  SET_SEARCH_TEXT_COLOR,
  SET_SEARCH_BORDER_COLOR,
  SET_SEARCH_BUTTON_STYLE,
  SET_SEARCH_BUTTON_BG_COLOR,
  SET_SEARCH_BUTTON_TEXT_ICON_COLOR,
  SET_SEARCH_BUTTON_CONTENT,
  SET_SEARCH_ICON_COLOR,
  SET_SEARCH_PLACEHOLDER_TEXT,
} from './action-names';

export function setTextWidth(data) {
  return {
    type: SET_SEARCH_TEXT_WIDTH,
    ...data
  };
};

export function setVerticalPadding(data) {
  return {
    type: SET_SEARCH_VERTICAL_PADDING,
    ...data
  };
};

export function setTextBgColor(data) {
  return {
    type: SET_SEARCH_TEXT_BG_COLOR,
    ...data
  };
};

export function setTextColor(data) {
  return {
    type: SET_SEARCH_TEXT_COLOR,
    ...data
  };
};

export function setBorderColor(data) {
  return {
    type: SET_SEARCH_BORDER_COLOR,
    ...data
  };
};

export function setButtonStyle(data) {
  return {
    type: SET_SEARCH_BUTTON_STYLE,
    ...data
  };
};

export function setButtonBgColor(data) {
  return {
    type: SET_SEARCH_BUTTON_BG_COLOR,
    ...data
  };
};

export function setButtonTextIconColor(data) {
  return {
    type: SET_SEARCH_BUTTON_TEXT_ICON_COLOR,
    ...data
  };
};

export function setButtonContent(data) {
  return {
    type: SET_SEARCH_BUTTON_CONTENT,
    ...data
  };
};

export function setIconColor(data) {
  return {
    type: SET_SEARCH_ICON_COLOR,
    ...data
  };
};

export function setPlaceholderText(data) {
  return {
    type: SET_SEARCH_PLACEHOLDER_TEXT,
    ...data
  };
};



// WEBPACK FOOTER //
// ./app/header-builder/actions/search-element-actions.js